import * as React from 'react';
import { useEffect } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DateUtil } from "../../fxms/datas/DateUtil";

/* 공장대시보드 에너지사용량 : 실시간 에너지 사용현황 */
export const FxDashChart2Cons = (props) => {
  const { energy, allValues, isDetailView, onDetailView } = props;
  const lineColor =
    energy === "EPWR" || energy === "EPWR_15" ? "#6fb7ff" : "#7ecd71";
  const fillColor =
    energy === "EPWR" || energy === "EPWR_15"
      ? "rgba(111, 183, 255, 0.18)"
      : "rgba(126, 205, 113, 0.16)";
  const unitSuffix = energy === "EPWR" || energy === "EPWR_15" ? "kWh" : "";

  //console.log("*** FxDashChart2Cons ***", energy, "allValues", allValues);
  const makeSeries = () => {

    const series = [];
    const values = allValues[energy];
    if (values) {
      const s = {};
      s.name = '사용량';
      s.type = 'areaspline';
      s.data = [];
      s.color = lineColor;
      s.lineWidth = 2.2;
      s.marker = { enabled: false };
      s.fillColor = {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, fillColor],
          [1, "rgba(0,0,0,0)"],
        ],
      };
 
      if (values !== undefined) {
        for (const data of values) {
          if("EPWR_15"==energy)
          {
            s.data.push([DateUtil.makeDate(data.psDate).getTime(), data.consAmt]);
          }else{
            s.data.push([DateUtil.makeDate(data.psDate).getTime(), data.consInstVal]);
          }
          
   
        }
      }
      series.push(s);
    }
    return series;
  }
  // 오늘 0시~24시
  const today = new Date();
  const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
  const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();

  const getChartData = (title) => {
    return {
      title: {
        text: title,
        align: "center",
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: " ",
        backgroundColor: "rgba(19, 26, 40, 0.95)",
        borderColor: "#4fc3f7",
        borderWidth: 1,
        borderRadius: 8,
        style: {
          color: "#edf4ff",
          fontSize: "12px",
        },
        formatter: function () {
          let tooltip = '<span style="font-size: 11px;color:#9eb9e8">' + Highcharts.dateFormat('%Y년 %m월 %d일 %H시 %M분', this.x) + '</span><br/>';
          this.points.forEach(function (point) {
            tooltip += '<span style="color:' + point.series.color + '">●</span> ' + point.series.name + ': <b>' + Highcharts.numberFormat(point.y || 0, 2) + '</b> ' + unitSuffix + '<br/>';
          });
          return tooltip;
        }
      },
      plotOptions: {
        series: {
          animation: {
            duration: 400,
          },
          cursor: 'pointer',
          marker: {
            lineWidth: 1
          }
        },
        areaspline: {
          threshold: null,
          linecap: "round",
        }
      },
      xAxis: {
        type: "datetime",
        lineColor: 'rgba(102, 118, 153, 0.55)',
        min: startOfDay,
        max: endOfDay,
        tickInterval: 3 * 60 * 60 * 1000, // ★ 3시간 단위(ms)로 레이블 표시
        tickColor: 'rgba(102, 118, 153, 0.55)',
        labels: {
          style: {
            color: "rgba(229,239,255,0.82)",
          },
          formatter: function () {
            let date = new Date(this.value);
            let hour = date.getHours();
            let minute = date.getMinutes();
            // 분이 0일 때만 시간을 표시
            if (minute === 0) {
              return hour + "시";
            }
            return '';  // 분이 0이 아닐 때는 빈 문자열 반환
          },
        },
      },
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          style: {
            color: "rgba(211, 223, 247, 0.75)",
            fontSize: "11px",
          },
        },
        lineWidth: 1,
        lineColor: '#3e3e3e',
        gridLineColor: 'rgba(115, 131, 171, 0.30)',
        gridLineDashStyle: 'ShortDot',
      },
      chart: {
        backgroundColor: "#2f3440",
        borderWidth: 1,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#2d323d",
        plotBorderWidth: 1,
        plotBorderColor: "#303030",
        events: {
          click: (e) => {
            if (onDetailView) {
              onDetailView(e);
            }
          },
          render: function () {
            if (this.wheelEventAdded) return;
            this.wheelEventAdded = true;
            this.container.addEventListener('wheel', (event) => {
              event.preventDefault();
              const chart = this;
              const xAxis = chart.xAxis[0];

              // 마우스 위치 → x축 값
              const rect = chart.container.getBoundingClientRect();
              const mouseX = event.clientX - rect.left;
              const xValue = xAxis.toValue(mouseX, true);

              const min = xAxis.min;
              const max = xAxis.max;
              const range = max - min;

              // 커서가 차지하는 비율
              const ratio = (xValue - min) / range;

              // 줌 인/아웃 비율
              const zoomFactor = event.deltaY < 0 ? 0.8 : 1.25;
              const newRange = range * zoomFactor;

              // 커서 위치 고정 계산
              let newMin = xValue - newRange * ratio;
              let newMax = xValue + newRange * (1 - ratio);

              // 최대 축소 상태라면 반드시 0시~24시로 복원
              if (newMin <= startOfDay && newMax >= endOfDay) {
                xAxis.setExtremes(startOfDay, endOfDay, true, false);
              } else {
                xAxis.setExtremes(newMin, newMax, true, false);
              }
            });
          }
        }
      },
      credits: {
        enabled: false,
      },
      series: makeSeries()
      ,
      legend: {
        enabled: false
      }
    };
  }

  useEffect(() => {
    const values = allValues[energy];
    if (values === undefined) {
      return;
    }
  }, [allValues, energy])

  return (
    <HighchartsReact
      containerProps={{ style: { height: isDetailView ? "450px" : "180px", width: "100%" } }}
      highcharts={Highcharts}
      options={getChartData('', '', '', '')}
    />
  );
}
